import { useTranslation } from 'react-i18next';

import { Wrapper, TextWrapper, Text, Description } from './EmptyRanking.styles';

type EmptyRankingProps = {
  courseName: string;
};

const ICON_SIZE = 30;

export const EmptyRanking: React.FC<EmptyRankingProps> = ({ courseName }) => {
  const { t } = useTranslation('StudentDashboardTranslations');
  return (
    <Wrapper>
      <span role="img" aria-label="Empty ranking" style={{ fontSize: ICON_SIZE }}>
        🏆
      </span>
      <TextWrapper>
        <Text>{t('ENTER_RANKING')}</Text>
        <Description>{t('GET_POINTS_TO_BE_IN_THE_RANKING', { courseName })}</Description>
      </TextWrapper>
    </Wrapper>
  );
};
